import { useEffect, useState } from "react";
import {
  CustomButton,
  CustomText,
  CustomTextInput,
  FallBack,
  Image,
  ModalComponent,
  PrimaryCta,
} from "../../components";
import CustomTable from "../../components/customTable";
import Header from "../header";
import { Loader } from "../loader";
import SideMenu from "../sideMenu";
import Utils from "../../common/utils";
import Core from "../../common/clientSdk";
import { toast } from "react-toastify";
import * as CampaignData from "../../common/data/campaign";
import InfluencerDetailModal from "../../modal/influencerDetialModal";
import Icon from "../../components/core_component/icon";
import { useSelector } from "react-redux";
import ExpandedComponent from "./expandedComponent";

const PriceRequestList = () => {
  const [priceRequestList, setPriceRequestList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [influencerId, setInfluencerId] = useState(null);
  const [influencerFlyOut, setInfluencerFlyOut] = useState(false);
  const [openSendPriceModal, setOpenSendPriceModal] = useState(false);
  const [price, setPrice] = useState();
  const [campaignId, setCampaignId] = useState(null);
  const [sendPriceLoading, setSendPriceLoading] = useState(false);
  const [openRejectPriceModal, setOpenRejectPriceModal] = useState(false);
  const [rejectPriceLoading, setRejectPriceLoading] = useState(false);
  const [acceptOfferLoading, setAcceptOfferLoading] = useState({});
  const [rejectBidLoading, setRejectBidLoading] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    priceList(1);
  }, []);

  const redux_selector = useSelector((state) => {
    return {
      UserData: state.BrandUserDataReducer,
      Auth: state.BrandUserAuthReducer,
    };
  });
  const { UserData = {} } = redux_selector;
  const { brand_deep_data = {} } = UserData;
  function priceListUpdateProgress(status) {
    setLoading(status);
  }
  function priceList(page = 1, limit = rowsPerPage) {
    const offset = (page - 1) * limit;
    let params = {
      start: offset,
      limit: limit,
    };

    console.log("Fetching price list with params:", params);

    Core.priceList(
      (res, response) => priceListSuccess(res, response, page),
      priceListFailed,
      priceListUpdateProgress,
      params,
    );
  }
  function priceListSuccess(res, response, page = 1) {
    console.log("Invite List:", response.invite_list);
    console.log("Pagination Data:", response?.pagination_data);
    console.log("Total Count:", response?.pagination_data?.total_count);
    console.log("Current Page:", page);
    console.log("Invite List Length:", response.invite_list?.length);

    if (
      Array.isArray(response.invite_list) &&
      response.invite_list.length > 0
    ) {
      setPriceRequestList(response.invite_list);
    } else {
      console.warn("Invite list is empty or not an array");
      setPriceRequestList([]);
    }

    setTotalRows(Number(response?.pagination_data?.total_count));
    setCurrentPage(page);
    setLoading(false);
  }

  function priceListFailed(errorList) {
    toast.error(errorList.map((item) => item.m).join(", "));
  }
  function getInflencerLocation(influencer_data) {
    if (influencer_data?.["city_id"]) {
      return CampaignData.CITY.find(
        (city) => city?.id == influencer_data["city_id"],
      )?.label;
    } else if (influencer_data?.["state"]) {
      return CampaignData.LOCATIONS[influencer_data["state"]]?.n;
    } else {
      return "-";
    }
  }

  function rejectPriceRequest() {
    let params = {
      campaign_id: campaignId,
      influencer_id: influencerId,
    };
    Core.rejectPriceRequest(
      rejectPriceRequestSuccess,
      rejectPriceRequestFailed,
      (status) => setRejectPriceLoading(status),
      params,
    );
  }

  function rejectPriceRequestSuccess() {
    toast.success("Price request rejected successfully");
    priceList(currentPage);
    setOpenRejectPriceModal(false);
    setInfluencerId(null);
    setCampaignId(null);
    setRejectPriceLoading(false);
  }
  function rejectPriceRequestFailed(errorList) {
    toast.error(errorList.map((item) => item.m).join(", "));
    setRejectPriceLoading(false);
  }
  const toggleFlyoutDropdown = () => {
    setInfluencerFlyOut(!influencerFlyOut);
  };
  function CampaignClick(campaignId) {
    window.open(`/campaigns/${campaignId}`, "_blank");
  }

  const tableSchema = [
    {
      name: "Influencers",
      selector: (row) => {
        const item = row?.data || row;
        const influencer =
          item?.influencer_data ||
          item?.influencer_deep_data?.influencer_data ||
          row?.influencer_data ||
          row?.influencer_deep_data?.influencer_data ||
          {};
        return influencer?.name || "";
      },
      width: "300px",

      cell: (row) => {
        const item = row?.data || row;
        const influencer =
          item?.influencer_data ||
          item?.influencer_deep_data?.influencer_data ||
          row?.influencer_data ||
          row?.influencer_deep_data?.influencer_data ||
          {};
        const influencerId =
          influencer?.influencer_id ||
          item?.influencer_id ||
          row?.influencer_id;

        return (
          <>
            <span
              onClick={() => {
                toggleFlyoutDropdown();
                setInfluencerId(influencerId);
              }}
              style={{
                display: "flex",
                gap: 8,
                alignItems: "center",
                padding: "10px 0",
              }}
            >
              <Image
                source={
                  influencer?.profile_picture
                    ? Utils.generateInfluencerDpUrl(
                        influencerId,
                        influencer?.profile_picture,
                      )
                    : require("../../resources/images/user-copy.png")
                }
                className={
                  influencer?.is_verified
                    ? "discovery-user-profile"
                    : "proposal-user-profile"
                }
              />
              <div style={{ flexDirection: "row", display: "flex", gap: 5 }}>
                <div>
                  <div
                    style={{ flexDirection: "row", display: "flex", gap: 5 }}
                  >
                    <CustomText p text={influencer?.name} className="Body-1" />
                  </div>
                  <span style={{ display: "flex" }}>
                    <span>
                      <CustomText
                        p
                        text={
                          getInflencerLocation(influencer)
                            ? getInflencerLocation(influencer)
                            : "-"
                        }
                        fontSize={"font_size_extraSmall"}
                        fontWeight={"rubik_regular"}
                        textColor={"text_color_primary"}
                        textAlign={"text_align_left"}
                      />
                    </span>
                    <span>
                      <CustomText
                        p
                        text={
                          influencer?.profession
                            ? `,${Utils.getSelectedSubCategoryObjects(influencer?.profession)}`
                            : ""
                        }
                        fontSize={"font_size_extraSmall"}
                        fontWeight={"rubik_regular"}
                        textColor={"text_color_primary"}
                        textAlign={"text_align_left"}
                      />
                    </span>
                    <span>
                      <CustomText
                        p
                        text={
                          influencer?.language ? `,${influencer?.language}` : ""
                        }
                        fontSize={"font_size_extraSmall"}
                        fontWeight={"rubik_regular"}
                        textColor={"text_color_primary"}
                        textAlign={"text_align_left"}
                      />
                    </span>
                  </span>
                  {influencer?.note && (
                    <div
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "200px",
                        lineHeight: "1.5",
                      }}
                    >
                      <CustomText
                        p
                        text={influencer?.note}
                        fontSize={"font_size_extraSmall"}
                        fontWeight={"rubik_regular"}
                        textColor={"text_color_primary"}
                        textAlign={"text_align_left"}
                      />
                    </div>
                  )}
                </div>
              </div>
            </span>
          </>
        );
      },
    },
    {
      name: "Followers",
      selector: (row) => {
        const influencer =
          row?.data?.platform_data ||
          row?.influencer_deep_data?.platform_data ||
          {};
        return (
          Utils.changeNumberFormate(influencer?.follower_count) ||
          Utils.changeNumberFormate(influencer?.followers) ||
          "-"
        );
      },
      textAlign: "center",
      maxWidth: "150px",
    },
    {
      name: "Status",
      selector: (row) => {
        const item = row?.data || row;
        return item?.invite_data?.status || item?.bid_data?.status || "-";
      },
      textAlign: "left",
      maxWidth: "150px",
    },
    {
      name: "Request Date",
      selector: (row) => {
        const item = row?.data || row;
        return Utils.formatDate(
          item?.invite_data?.date_added ||
            item?.bid_data?.date_added ||
            item?.date_added,
        );
      },
      textAlign: "left",
      maxWidth: "150px",
    },
  ];
  if (priceRequestList.some((item) => item?.data?.bid_data?.counter_value)) {
    tableSchema.push({
      name: "Counter Value",
      cell: (row) => {
        const item = row;
        const bidData = item?.bid_data || item?.data?.bid_data;
        const isCounter =
          bidData?.is_counter === 1 || bidData?.is_counter === "1";
        const status = bidData?.status || item?.status;

        if (isCounter && status === "IN_REVIEW" && bidData?.counter_value > 0) {
          return (
            <div style={{ textAlign: "left" }}>
              <CustomText p text={`₹${bidData?.counter_value}`} />
            </div>
          );
        }
        return "-";
      },
      textAlign: "left",
    });
  }
  tableSchema.push({
    name: "",
    cell: (data) => {
      // Determine type (support multiple shapes)
      const topType = data?.type || data?.data?.type;
      const isInvite =
        topType === "invite" ||
        !!data?.invite_data ||
        !!data?.data?.invite_data;
      const bidData =
        data?.bid_data || data?.data?.bid_data || data?.data?.data?.bid_data;
      const isBid = topType === "bid" || !!bidData;
      const isCounter =
        !!bidData && (bidData.is_counter === 1 || bidData.is_counter === "1");

      if (isInvite) {
        const inviteStatus =
          data?.invite_data?.status || data?.data?.invite_data?.status;
        return (
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            {inviteStatus !== "REJECTED" && (
              <span style={{}}>
                <PrimaryCta
                fifth
                text={"Send Price"}
                  onClick={() => {
                    setOpenSendPriceModal(true);
                    setInfluencerId(data?.data?.invite_data?.influencer_id);
                    setCampaignId(data?.data?.invite_data?.campaign_id);
                    console.log("influencerId123456", influencerId);
                  }}
                />
              </span>
            )}
            <span>
              <PrimaryCta
              invertSmall
              disabled={inviteStatus === "REJECTED"}
              text={
                  inviteStatus === "REJECTED"
                    ? "Price Rejected"
                    : "Reject Price"
                }
                onClick={() => {
                  setOpenRejectPriceModal(true);
                  setInfluencerId(data?.data?.invite_data?.influencer_id);
                  setCampaignId(data?.data?.invite_data?.campaign_id);
                  console.log("influencerId123456", influencerId);
                }}
              />
            </span>
          </div>
        );
      }

      if (isBid) {
        const bidId = bidData?.bid_id;
        const bidStatus = bidData?.status || data?.data?.bid_data?.status;

        if (bidStatus === "ACCEPTED" || bidStatus === "APPROVED") {
          return (
            <div
              style={{ display: "flex", alignItems: "center", minHeight: 40 }}
            >
              <CustomText
                p
                text={"Bid Approved"}
                textColor={"text_completed_color"}
              />
            </div>
          );
        }
        if (bidStatus === "IN_REVIEW" && !bidData?.counter_value) {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                minHeight: 40,
                color: "var(--gray-gray-400)",
              }}
            >
              <CustomText p text={"Bid In Review"} />
            </div>
          );
        }
        if (bidStatus === "REJECTED") {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                minHeight: 40,
                color: "var(--general-error)",
              }}
            >
              <CustomText p text={"Bid Rejected"} />
            </div>
          );
        }

        if (isCounter && bidData?.counter_value) {
          return (
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <span style={{}}>
                <CustomButton
                  text={"Accept"}
                  onClick={() => acceptBid(bidId)}
                  fontSize={"font_size_small"}
                  borderRadius={4}
                  padding={{ top: 12, right: 12, bottom: 12, left: 12 }}
                  textColor={"text_color_light"}
                  background={"#090A14"}
                  border={"none"}
                  boxShadow={"none"}
                  hoverColor={"var(--hover-color, #1977F2)"}
                  isLoading={acceptOfferLoading[bidId] || false}
                />
              </span>
              <span>
                <CustomButton
                  text={"Reject"}
                  onClick={() => rejectBid(bidId)}
                  fontSize={"font_size_small"}
                  borderRadius={4}
                  padding={{ top: 12, right: 12, bottom: 12, left: 12 }}
                  textColor={"text_color_light"}
                  background={"#090A14"}
                  border={"none"}
                  boxShadow={"none"}
                  hoverColor={"var(--hover-color, #1977F2)"}
                  isLoading={rejectBidLoading[bidId] || false}
                />
              </span>
            </div>
          );
        }

        // Bid without counter: no actions
        return <div style={{ minHeight: 40 }} />;
      }

      return null;
    },
  });

  function acceptBid(bid_id) {
    const params = { bid_id };
    setAcceptOfferLoading((prev) => ({ ...prev, [bid_id]: true }));
    Core.acceptOffer(
      () => {
        toast.success("Offer Accepted");
        setAcceptOfferLoading((prev) => ({ ...prev, [bid_id]: false }));
        priceList(currentPage);
      },
      (errorList) => {
        toast.error(errorList?.map((item) => item?.m).join(", "));
        setAcceptOfferLoading((prev) => ({ ...prev, [bid_id]: false }));
      },
      (status) =>
        setAcceptOfferLoading((prev) => ({ ...prev, [bid_id]: status })),
      params,
    );
  }

  function rejectBid(bid_id) {
    const params = { bid_id };
    setRejectBidLoading((prev) => ({ ...prev, [bid_id]: true }));
    Core.rejectOffer(
      () => {
        toast.success("Offer Rejected");
        setRejectBidLoading((prev) => ({ ...prev, [bid_id]: false }));
        priceList(currentPage);
      },
      (errorList) => {
        toast.error(errorList?.map((item) => item?.m).join(", "));
        setRejectBidLoading((prev) => ({ ...prev, [bid_id]: false }));
      },
      (status) =>
        setRejectBidLoading((prev) => ({ ...prev, [bid_id]: status })),
      params,
    );
  }

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "var(--general-secondary-color)", // Change header background color
        color: "var(--gray-gray-300)", // Change header text color
        fontSize: "16px",
        fontWeight: 600,
        lineHight: "19.2px",
        border: "none",
      },
    },
    headCells: {
      style: {
        padding: "10px 0px 10px 20px",
      },
    },
    rows: {
      style: {
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: 400,
        lineHight: "19.2px",
        "&:hover": {
          backgroundColor: "var(--general-secondary-color)",
          fontWeight: 600,
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "20px",
      },
    },
  };

  function sendPriceUpdateProgress(status) {
    setSendPriceLoading(status);
  }
  function sendPrice() {
    let params = {
      campaign_id: campaignId,
      influencer_id: influencerId,
      bid_data: JSON.stringify({
        type: "cash",
        value: price,
        proposal_note: "abc",
      }),
    };
    console.log("params000", params);
    Core.sendPrice(
      sendPriceSuccess,
      sendPriceFailed,
      sendPriceUpdateProgress,
      params,
    );
  }
  function sendPriceSuccess() {
    toast.success("Price sent");
    setOpenSendPriceModal(false);
    setSendPriceLoading(false);
    priceList(currentPage);
  }
  function sendPriceFailed(errorList) {
    toast.error(errorList.map((item) => item.m).join(", "));
  }

  function ExpandedComponentData(item) {
    return (
      <ExpandedComponent
        item={item}
        influencerId={influencerId}
        campaignId={campaignId}
      />
    );
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
    priceList(page);
  };
  return (
    <div className="dashboard-container">
      <SideMenu />

      <div className="main-screen">
        <Header />
        <div className="page-container-campaignList">
          <div className="campaignlist-header">
            <div>
              <CustomText
                p
                text={"Price Request"}
                fontWeight={600}
                textColor={"text_color_primary"}
                textAlign={"text_align_left"}
              />
            </div>
          </div>
          {loading ? (
            <div className="loader-mid">
              <Loader />
            </div>
          ) : (
            <>
              {priceRequestList?.length !== 0 ? (
                <>
                  <div className="custom-table">
                    <CustomTable
                      className="CustomTable"
                      tableSchema={tableSchema}
                      tableData={priceRequestList}
                      paginationPerPage={rowsPerPage}
                      paginationDefaultPage={currentPage}
                      rowPaddingTop={20}
                      rowPaddingBottom={30}
                      customStyles={customStyles}
                      onChangePage={handlePageChange}
                      paginationTotalRows={totalRows}
                      paginationServer
                      pagination
                      onChangeRowsPerPage={(
                        currentRowsPerPage,
                        currentPage,
                      ) => {
                        setRowsPerPage(currentRowsPerPage);
                        setCurrentPage(1);
                        priceList(1, currentRowsPerPage);
                      }}
                      // expandableRows={true}
                      // expandableRowsComponent={({ data }) => (
                      //   <ExpandedComponent
                      //     item={data}
                      //   //   influencerId={influencerId}
                      //   //   campaignId={campaignId}
                      //   />
                      // )}
                    />
                  </div>
                </>
              ) : (
                <div className="fallback">
                  <FallBack heading={"No Price List"} />
                </div>
              )}
            </>
          )}
          {influencerFlyOut && (
            <InfluencerDetailModal
              influencerFlyOut={influencerFlyOut}
              toggleFlyoutDropdown={toggleFlyoutDropdown}
              influencer_id={influencerId}
            />
          )}
          {
            <ModalComponent
              isOpen={openSendPriceModal}
              onRequestClose={() => setOpenSendPriceModal(!openSendPriceModal)}
              customStyle={{
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 999999,
                },
                content: {
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  backgroundColor: "#F0F3F9",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
                  overflowY: "none",
                  height: "40%",
                  width: "30%",
                },
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="">
                  <CustomText p text={`Send Price`} textColor={"#040408"} />
                </div>
                <div
                  onClick={() => setOpenSendPriceModal(!openSendPriceModal)}
                  className="close-icon-brand-list"
                >
                  <Icon iconName="CloseRoundButtonIcon" />
                </div>
              </div>
              <div
                style={{
                  display: "flex ",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="m-t-20" style={{ width: "100%" }}>
                  <div className="">
                    <CustomText
                      p
                      text={`Price`}
                      textColor={"#040408"}
                      className="m-b-12"
                    />
                  </div>
                  <div className="">
                    <CustomTextInput
                      type="name"
                      placeholder="Price"
                      //   value={price}
                      onChange={(e) => setPrice(e.target.value)}
                    />
                  </div>
                </div>
                <div style={{ marginTop: 20 }}>
                  <PrimaryCta
                    third
                    fontSize={"font_size_regular"}
                    text={"Send"}
                    onClick={() => {
                      sendPrice();
                    }}
                    isLoading={sendPriceLoading}
                  />
                </div>
              </div>
            </ModalComponent>
          }
          {openRejectPriceModal && (
            <ModalComponent
              isOpen={openRejectPriceModal}
              onRequestClose={() => setOpenRejectPriceModal(false)}
              customStyle={{
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 999999,
                },
                content: {
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  backgroundColor: "#F0F3F9",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
                  overflowY: "none",
                  height: "30%",
                  width: "30%",
                },
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <CustomText
                    p
                    text={`Reject Price Request`}
                    textColor={"#040408"}
                  />
                </div>
                <div
                  onClick={() => {
                    setOpenRejectPriceModal(false);
                    setInfluencerId(null);
                    setCampaignId(null);
                  }}
                  className=""
                  style={{ cursor: "pointer" }}
                >
                  <Icon iconName="CloseRoundButtonIcon" />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 30,
                }}
              >
                <CustomText
                  p
                  text={`Are you sure you want to reject this price request?`}
                  textColor={"#040408"}
                  className="m-b-12"
                />
                <div style={{ marginTop: 30, display: "flex", gap: 16 }}>
                  <PrimaryCta
                    third
                    fontSize={"font_size_regular"}
                    text={"Reject"}
                    onClick={() => {
                      rejectPriceRequest();
                    }}
                    isLoading={rejectPriceLoading}
                  />
                </div>
              </div>
            </ModalComponent>
          )}
        </div>
      </div>
    </div>
  );
};
export default PriceRequestList;
